import React from 'react';
import PropsTypes from 'prop-types';
import classNames from 'classnames';
import { Link as RouterLink } from '@bingads-webui-react/router';
import { Glyphicon } from '@bingads-webui-react/primitive';


export const BackButton = ({
  classes, url, buttonText, onClick,
}) => (
  <RouterLink
    to={url}
    className={classNames(classes.backButton, 'back-button')}
    onClick={onClick}
  >
    <Glyphicon
      className={classes.backButtonIcon}
      glyph="ba-Back"
    />
    {buttonText}
  </RouterLink>
);

BackButton.propTypes = {
  classes: PropsTypes.shape({}).isRequired,
  url: PropsTypes.string,
  buttonText: PropsTypes.string.isRequired,
  onClick: PropsTypes.func,
};

BackButton.defaultProps = {
  url: '',
  onClick: null,
};

